import React from "react";
import styled from "styled-components";

import calendarCheck from "../assets/svg/calendarCheck.svg";
import globeCircled from "../assets/svg/globeCircled.svg";
import page from "../assets/svg/page.svg";
import speechBubbles from "../assets/svg/speechBubbles2.svg";

type DataType = {
  imgSrc: string;
  title: string;
  description: JSX.Element;
};

const DATA: DataType[] = [
  {
    imgSrc: page,
    title: "Print promotions",
    description: (
      <ul className="bullet-fulcrum bullet-gold text-white mb-4">
        <li>
          <p>
            Create eye-catching posters and place them in high-traffic areas
          </p>
        </li>
        <li>
          <p>Include a message in your staff newsletter</p>
        </li>
        <li>
          <p>Place a flyer in staff pigeonholes or with payslips</p>
        </li>
      </ul>
    ),
  },
  {
    imgSrc: globeCircled,
    title: "Online promotions",
    description: (
      <ul className="bullet-fulcrum bullet-gold text-white mb-4">
        <li>
          <p>Include a message on your intranet</p>
        </li>
        <li>
          <p>Email staff and set calendar reminders about events</p>
        </li>
        <li>
          <p>Use social media such as Facebook and Twitter to notify staff</p>
        </li>
      </ul>
    ),
  },
  {
    imgSrc: speechBubbles,
    title: "Talk",
    description: (
      <ul className="bullet-fulcrum bullet-gold text-white mb-4">
        <li>
          <p>Speak to employees at staff or team meetings</p>
        </li>
        <li>
          <p>
            Utilise enthusiastic managers of staff members to spread the word
          </p>
        </li>
        <li>
          <p>Share any successes or positive experiences from staff members</p>
        </li>
      </ul>
    ),
  },
  {
    imgSrc: calendarCheck,
    title: "Program launch event",
    description: (
      <ul className="bullet-fulcrum bullet-gold text-white mb-4">
        <li>
          <p>Get support from senior management</p>
        </li>
        <li>
          <p>Invite an interesting guest speaker</p>
        </li>
        <li>
          <p>Provide a healthy breakfast, lunch or morning tea</p>
        </li>
        <li>
          <p>
            Give away pedometers or other incentives to encourage attendance
          </p>
        </li>
      </ul>
    ),
  },
];

export const ProgramPromotion: React.FC<{}> = () => {
  return (
    <div className="col-md-10 offset-md-1 col-lg-8 offset-lg-2 d-flex flex-column">
      <h2 className="h1 text-uppercase text-warning text-center my-4">Program promotion</h2>
      <p className="mb-1">
        Once you have established what motivates your employees and identified
        suitable strategies, the final step is to effectively communicate to
        them. Promotion is essential in engaging your staff as it will allow you
        to:
      </p>
      <ul className="bullet-fulcrum bullet-gold">
        <li>Raise awareness</li>
        <li>Generate interest</li>
        <li>Motivate participation</li>
        <li>Keep participants interested and involved</li>
      </ul>
      <p>
        We have listed a few program promotion suggestions you might find
        useful:
      </p>
      <StyledGroup className="row rounded">
        {DATA.map(({ imgSrc, title, description }) => (
          <div
            key={title}
            className="col-6 d-flex flex-column border-white align-items-center p-4"
          >
            <StyledIcon>
              <img src={imgSrc} alt={`${title} icon`} />
            </StyledIcon>
            <h3 className="text-center text-gold mb-3">{title}</h3>
            {description}
          </div>
        ))}
      </StyledGroup>
    </div>
  );
};

const StyledGroup = styled.div`
  background-color: ${(props) => props.theme.info};
  div {
    border: solid 1px white;
  }
`;

const StyledIcon = styled.i`
  width: 100px;
  height: 100px;
  margin-bottom: 1.5rem;
  padding: 1rem;
  border-radius: 50%;
  background-color: white;
`;
